/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class MarkerIcon {
    public get(color: string = '#ff0000', scale: string = 'medium'):object {
        let iconScale:number = 2
        let iconAnchor:any = new google.maps.Point(12, 17)

        if (scale === 'large') {
            iconScale = 3
            iconAnchor = new google.maps.Point(12, 18.5)
        }

        // Pick your pin (hole or no hole)
        const pinSVGHole = "M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"
        const labelOriginFilled =  new google.maps.Point(12, 9)

        const markerImage = {  // https://developers.google.com/maps/documentation/javascript/reference/marker#MarkerLabel
            path: pinSVGHole, //Filled,
            anchor: iconAnchor,
            fillOpacity: 1,
            fillColor: color,
            strokeWeight: 2,
            strokeColor: this.darkenHexColor(color),
            scale: iconScale,
            labelOrigin: labelOriginFilled
        }

        return markerImage
    }

    private darkenHexColor(hex: string, percent: number = 20) {
        // Parse the hex color string to RGB values
        var r = parseInt(hex.substring(1, 3), 16)
        var g = parseInt(hex.substring(3, 5), 16)
        var b = parseInt(hex.substring(5, 7), 16)

        // Darken the RGB values
        r = Math.round(r * (1 - percent / 100))
        g = Math.round(g * (1 - percent / 100))
        b = Math.round(b * (1 - percent / 100))

        // Convert the darkened RGB values back to hex
        var darkenedHex = '#' + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)

        return darkenedHex
    }
}

/**
 *     @section 3. Export class
 */

export default new MarkerIcon()

// end of marker-icon.ts file
